import { Stethoscope, BadgeCheck, FileText, UserRound, ClipboardList, Smartphone } from "lucide-react";
import { FadeUp, SlideTitle } from "../Deck";

const PANELS = [
  {
    tag: "Doctors",
    items: [
      {
        icon: Stethoscope,
        h: "You stay in charge",
        p: "Your diagnosis and goals travel with the patient.",
      },
      {
        icon: BadgeCheck,
        h: "Verified physiotherapists",
        p: "Only credentialed clinicians receive your orders.",
      },
      {
        icon: FileText,
        h: "Outcomes back to you",
        p: "Progress reports arrive. No referral commissions, ever.",
      },
    ],
  },
  {
    tag: "Physiotherapists",
    items: [
      {
        icon: UserRound,
        h: "Never an employer",
        p: "Your practice remains your own.",
      },
      {
        icon: ClipboardList,
        h: "Ready-to-treat orders",
        p: "Each case arrives with diagnosis and goals.",
      },
      {
        icon: Smartphone,
        h: "PranIQ Pro",
        p: "Schedule, notes and reporting in one mobile app.",
      },
    ],
  },
];

export default function Slide07Clinicians() {
  return (
    <div>
      <SlideTitle>
        The people who <em className="italic text-gold">deliver care</em>
      </SlideTitle>
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {PANELS.map((panel, i) => (
          <FadeUp
            key={panel.tag}
            delay={0.1 + i * 0.12}
            className="h-full rounded-3xl border border-line bg-white p-8 md:p-10"
          >
            <span className="inline-block rounded-full bg-mint px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-teal-deep">
              {panel.tag}
            </span>
            <div className="mt-7 space-y-6">
              {panel.items.map((item) => (
                <div key={item.h} className="flex gap-4">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-bone2 text-teal">
                    <item.icon size={17} strokeWidth={1.8} />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold tracking-tight">
                      {item.h}
                    </h3>
                    <p className="mt-1 text-sm leading-relaxed text-mut">
                      {item.p}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  );
}
